import React, { useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { GBENSContext } from '../GBENSContainer';

import Row from './_Row';

export const DateTimePickerComponent = ({ id, screen, modal, name, toolTip, rowProps, disabled }) => {
  const { data, updateData, errors } = useContext(GBENSContext);
  const _error = errors?.[screen]?.[id] ? errors[screen][id] : null;

  useEffect(() => {
    if (typeof dateInObject === 'string') updateData(dayjs(dateInObject), screen, id + 'DateTime', modal);
  }, [data]);

  const dateInObject = useMemo(() => {
    return modal ? data?.[screen]?.[modal]?.[id + 'DateTime'] : data?.[screen]?.[id + 'DateTime'];
  }, [data]);

  const hourInObject = useMemo(() => {
    return modal ? data?.[screen]?.[modal]?.[id + 'DateTime']?.hour?.() : data?.[screen]?.[id + 'DateTime']?.hour?.();
  }, [data]);

  const minuteInObject = useMemo(() => {
    return modal
      ? data?.[screen]?.[modal]?.[id + 'DateTime']?.minute?.()
      : data?.[screen]?.[id + 'DateTime']?.minute?.();
  }, [data]);

  const updateDateComponent = (e, type) => {
    let newDate;
    switch (type) {
      case 'date':
        newDate = dayjs();
        newDate = newDate.year(e.year());
        newDate = newDate.month(e.month());
        newDate = newDate.date(e.date());
        if (!dateInObject) {
          newDate = newDate.hour(0);
          newDate = newDate.minute(0);
        }
        updateData(newDate, screen, id + 'DateTime', modal);
        break;
      case 'hour':
        if (!dateInObject) {
          newDate = dayjs();
          newDate = newDate.hour(e);
          newDate = newDate.minute(0);
        } else {
          newDate = dayjs(dateInObject);
          newDate = newDate.hour(e);
        }
        updateData(newDate, screen, id + 'DateTime', modal);
        break;
      case 'minute':
        if (!dateInObject) {
          newDate = dayjs();
          newDate = newDate.hour(0);
          newDate = newDate.minute(e);
        } else {
          newDate = dayjs(dateInObject);
          newDate = newDate.minute(e);
        }
        updateData(newDate, screen, id + 'DateTime', modal);
        break;
    }
  };

  const hourOptions = Array(24)
    .fill()
    .map((_, i) => i);
  const minuteOptions = Array(60)
    .fill()
    .map((_, i) => i);
  return (
    <Row
      name={name}
      warning={_error}
      toolTip={toolTip}
      rowProps={rowProps}
      component={
        <div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ marginRight: 20 }}>
              <DatePicker
                id={id + 'DateTime'}
                onChange={(e) => updateDateComponent(e, 'date')}
                value={dateInObject}
                format="DD/MM/YYYY"
                disabled={disabled}
              />
            </div>
            <Select
              id={id}
              value={hourInObject ?? 0}
              onChange={(e) => updateDateComponent(e.target.value, 'hour')}
              disabled={disabled}
            >
              {hourOptions.map((h) => (
                <MenuItem key={h} value={h}>
                  {h}
                </MenuItem>
              ))}
            </Select>
            <Select
              id={id}
              defaultValue={minuteInObject}
              value={minuteInObject ?? 0}
              onChange={(e) => updateDateComponent(e.target.value, 'minute')}
              disabled={disabled}
            >
              {minuteOptions.map((m) => (
                <MenuItem key={m} value={m}>
                  {m}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      }
    />
  );
};

DateTimePickerComponent.propTypes = {
  id: PropTypes.string,
  screen: PropTypes.string,
  modal: PropTypes.string,
  name: PropTypes.string,
  toolTip: PropTypes.string,
  rowProps: PropTypes.object,
};

export default DateTimePickerComponent;
